import log from 'loglevel';
import EF from 'ef/ef';
import _ from 'lodash';

class ConsoleLogger {
  constructor() {
    if (!ConsoleLogger.instance) {
      this.isWebPage = typeof window != undefined;
      this.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 };
      ConsoleLogger.instance = this;
    }

    return ConsoleLogger.instance;
  }

  info(message) {
    return log.info(message);
  }

  debug(message) {
    return log.debug(message);
  }

  warn(message) {
    return log.warn(message);
  }

  error(message) {
    return log.error(message);
  }

  trace(message) {
    return log.trace(message);
  }

  logToConsole(msg, logLevel = 'warn') {
    if (!msg) {
      this.error('message is not defined');
      return;
    }

    const level = this.getLogLevel(logLevel);
    const message = this.envLog(msg);

    if (!message) {
      this.error('Will not log is not on a webpage');
      return;
    }

    // TODO: Send error object to a remote logger (TBD);
    switch (level) {
      case this.levels.TRACE:
        return this.trace(message);
      case this.levels.DEBUG:
        return this.debug(message);
      case this.levels.INFO:
        return this.info(message);
      case this.levels.WARN:
        return this.warn(message);
      case this.levels.ERROR:
        return this.error(message);
      default:
        console.error('Invalid log level:', level);
    }
  }

  envLog(msg) {
    if (this.isWebPage) {
      if (this.getEnvironment() === 'dev') {
        return msg;
      } else {
        if (_.isObjectLike(msg) && msg.error) {
          return msg.error;
        }
        return msg;
      }
    }
  }

  getEnvironment() {
    return EF.config.get('env');
  }

  getLogLevel(level) {
    if (typeof level === 'number') {
      return level;
    }

    level = typeof level === 'string' && level.toUpperCase();

    if (!this.levels[level]) {
      this.info(`${level} is not part of the logger facade. Defaulting to error`);
      return this.levels.ERROR;
    }

    return this.levels[level];
  }
}

const instance = new ConsoleLogger();
export default instance;
